import './index.css'

const FiltersGroup = () => (
  <div className="filters-group-container">
    <h1>Filters Group</h1>
    {/* Replace this element with your code */}
  </div>
)

export default FiltersGroup
